export enum CheckboxSizes {
  Large = 'large',
  Small = 'small',
}
